import COOKIES from '~/constants/cookies';
import Cookies from '~/utilities/BrowserCookies';

// Armed when the shopper leaves the SRP, so the server can tell a return from a reload.
export function armSrpResumeMarker(pathname: string): void {
  if (typeof window === 'undefined') return;

  Cookies.set(COOKIES.srpResume, pathname, {
    path: '/',
    sameSite: 'lax',
    secure: window.location.protocol === 'https:'
  });
}

export function getSrpResumeMarker(): string | undefined {
  return Cookies.get(COOKIES.srpResume);
}

export function clearSrpResumeMarker(): void {
  if (typeof window === 'undefined') return;

  Cookies.remove(COOKIES.srpResume, { path: '/' });
}

// Same-site, same-tab links to another page leave the SRP; modified clicks and new tabs do not.
export function isSrpExitClick(event: MouseEvent): boolean {
  if (event.button !== 0) return false;
  if (event.altKey || event.ctrlKey || event.metaKey || event.shiftKey) {
    return false;
  }

  const anchor =
    event.target instanceof Element
      ? event.target.closest<HTMLAnchorElement>('a[href]')
      : null;

  if (!anchor || anchor.hasAttribute('download')) return false;
  if (anchor.target && anchor.target !== '_self') return false;

  const { location } = window;
  const url = new URL(anchor.href, location.href);

  return url.origin === location.origin && url.pathname !== location.pathname;
}
